import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardRequestSuccessComponent from './cardRequestSuccess.component';

let cardRequestSuccessModule = angular.module('cardRequestSuccess', [
  uiRouter
])

.component('cardRequestSuccess', cardRequestSuccessComponent)

.name;

export default cardRequestSuccessModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestSuccess/cardRequestSuccess.js